<div class="content-wrapper">
    <app-navigation></app-navigation>
    <app-content-transition></app-content-transition>
    <app-header title="Dashboard"></app-header>
    <section class="content mb-4">
        <div class="row mb-4">
            <div class="col-md-12 section-heading">
                {{ companyService.getSelectedCompanyName() }} Sales
                <hr class="hr-margin-none" />
            </div>
        </div>
        <div class="d-flex align-items-baseline">
            <div class="sales-dashboard" *ngIf="!spinnerWavesBalance">
                <app-sales-dashboard></app-sales-dashboard>
            </div>
        </div>
    </section>
</div>
<div class="control-sidebar-bg"></div>
